/*
 * @Author: lijing
 * @Date: 2022-09-01 15:33:28
 * @Last Modified by: lijing
 * @Last Modified time: 2022-09-08 17:03:40
 */
import React, { FC, useEffect, useState } from "react";
import { Form, Select, Space, Button, Input, InputNumber, message } from "antd";
import { ruleInfo, ruleUpdate } from "@root/common/service";
const { Option } = Select;
const formItemChildStyle = {
  width: 230,
};

const LearnSettings: FC = () => {
  const [form] = Form.useForm();
  const [initValue, setInitValue] = useState({
    canDrag: 3,
    fastForward: 3,
    videoFinishPercent: 95,
    preventOnHook: 0,
    onHookTip: "",
    randomPopUpNum: 0,
  });

  const onFinish = (values: any) => {
    ruleUpdate(values).then((res) => {
      message.success("保存成功");
    });
  };

  useEffect(() => {
    ruleInfo().then((res) => {
      form.setFieldsValue(res.data);
    });
  }, []);

  return (
    <div className="coursepreview-tags">
      <Form
        form={form}
        labelCol={{ span: 3 }}
        wrapperCol={{ span: 8 }}
        colon={false}
        initialValues={initValue}
        onFinish={onFinish}
      >
        <Form.Item
          label="是否允许拖动"
          name="canDrag"
          rules={[
            {
              required: true,
              message: "",
            },
          ]}
        >
          <Select style={formItemChildStyle}>
            <Option value={3}>学习完成可拖动</Option>
            <Option value={2}>可以拖动</Option>
            <Option value={1}>不可以拖动</Option>
          </Select>
        </Form.Item>
        <Form.Item
          label="是否允许倍速"
          name="fastForward"
          rules={[
            {
              required: true,
              message: "",
            },
          ]}
        >
          <Select style={formItemChildStyle}>
            <Option value={3}>学习完成可倍速</Option>
            <Option value={2}>可以倍速</Option>
            <Option value={1}>不可以倍速</Option>
          </Select>
        </Form.Item>
        <Form.Item label="学习完成百分比" name="videoFinishPercent">
          <InputNumber style={formItemChildStyle} min={0} />
        </Form.Item>
        <Form.Item label="防挂机" name="preventOnHook">
          <Select style={formItemChildStyle}>
            <Option value={0}>关闭</Option>
            <Option value={1}>开启</Option>
          </Select>
        </Form.Item>
        <Form.Item
          noStyle
          shouldUpdate={(prevValues, curValues) =>
            prevValues.preventOnHook !== curValues.preventOnHook
          }
        >
          {({ getFieldValue }) =>
            getFieldValue("preventOnHook") === 1 && (
              <>
                <Form.Item
                  label="随机次数"
                  name="randomPopUpNum"
                  rules={[
                    {
                      required: true,
                      message: "请输入随机次数",
                    },
                  ]}
                >
                  <InputNumber style={formItemChildStyle} />
                </Form.Item>
                <Form.Item
                  label="提示语"
                  name="onHookTip"
                  rules={[
                    {
                      required: true,
                      message: "请输入随机次数",
                    },
                  ]}
                >
                  <Input style={formItemChildStyle} />
                </Form.Item>
              </>
            )
          }
        </Form.Item>

        <Form.Item label=" ">
          <Space>
            <Button>取消</Button>
            <Button type="primary" htmlType="submit">
              确定
            </Button>
          </Space>
        </Form.Item>
      </Form>
    </div>
  );
};

export default LearnSettings;
